import { UploadApp } from '../../../components/service/accounts/me/apps/UploadApp';
export const UploadPageView = () => {
  return <UploadApp data-sentry-element="UploadApp" data-sentry-component="UploadPageView" data-sentry-source-file="upload.tsx" />;
};